module.exports = __webpack_public_path__ + "static/media/social.006ab613.svg";